import { enFlowUnit } from 'application/project/api/Project';
import { RadioSelector } from 'components/controls/RadioSelector';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export const FlowUnitSelector = (props: {
  value: number | undefined;
  name: string;
  onChange: (value: number | undefined, name: string, error: string) => any;
}) => {
  const { t } = useTranslation(['project']);
  const options = React.useMemo(
    () => [
      { id: enFlowUnit.m3_h, name: t('flowunit_m3h', 'm3/h') },
      { id: enFlowUnit.dm3_s, name: t('flowunit_ls', 'dm3/s') },
    ],
    [t]
  );

  return (
    <RadioSelector
      label={t('flowunit', 'flow unit')}
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      valueFieldName="id"
      displayFieldName="name"
      options={options}
    />
  );
};
